import { RELATIVE } from '@yme/common/constants';
import { formatPrice } from '@yme/utils/formatPrice';
export function getMasterProduct(productCardPanelVariants) {
    const masterProduct = productCardPanelVariants.find((item) => item.masterData) || productCardPanelVariants[0];
    return masterProduct;
}
export function prepareProductsUrls({ currentSku, currentUrl, addedRequiredProducts, }) {
    return addedRequiredProducts.reduce((acc, requiredProduct) => {
        acc.push({
            sku: requiredProduct?.sku,
            productUrl: requiredProduct?.productUrl,
        });
        return acc;
    }, [
        {
            sku: currentSku,
            productUrl: currentUrl,
        },
    ]);
}
export const calculateDiscountPercent = (regularPrice, discountValue) => {
    const discountPercent = (discountValue / regularPrice) * 100;
    return discountPercent.toFixed(2);
};
export const calculateDiscountPercentFromLatestLowerPrice = (lastLowestPrice, discountedPrice) => {
    const percent = ((discountedPrice - lastLowestPrice) / lastLowestPrice) * 100;
    if (percent > 0) {
        return `+${percent.toFixed(2)}%`;
    }
    return `-${Math.abs(percent).toFixed(2)}%`;
};
export const getPreviousDiscountArr = (history) => {
    return history
        .filter((item) => Boolean(item?.endDate))
        .map((item) => {
        const { endDate, startDate, type, discountValue, discountedValue } = item;
        return {
            type: type.toLowerCase(),
            discountValue: +discountValue,
            discountedValue: +discountedValue,
            endDate: endDate,
            startDate,
        };
    });
};
export const formattedLastMonthDiscount = ({ lastLowestPrice, regularPrice, currencyCode, locale, currentDiscount, }) => {
    const { discountType, discountValue, discountedPrice } = currentDiscount;
    const discountPercent = discountType === RELATIVE
        ? discountValue
        : calculateDiscountPercent(regularPrice, discountValue);
    const currentDiscountPercent = lastLowestPrice !== regularPrice ? discountPercent : undefined;
    const discountPercentFromLatestLowerPrice = calculateDiscountPercentFromLatestLowerPrice(lastLowestPrice, discountedPrice);
    const formattedLastLowestPrice = formatPrice({
        locale,
        currencyName: currencyCode,
        price: lastLowestPrice,
    });
    const formattedRegularPrice = formatPrice({
        locale,
        currencyName: currencyCode,
        price: regularPrice,
    });
    return {
        discountPercentFromLatestLowerPrice,
        currentDiscountPercent,
        formattedLastLowestPrice,
        formattedRegularPrice,
    };
};
export const getLastMonthDiscountObject = ({ priceDiscountHistory, priceAttribute, locale, isOmnibusRegulationEnabled, }) => {
    const { discount: currentDiscount, currencyCode, amount } = priceAttribute;
    if (!currentDiscount || !isOmnibusRegulationEnabled)
        return null;
    const previousDiscountArr = getPreviousDiscountArr(priceDiscountHistory?.history);
    if (currentDiscount && !previousDiscountArr.length) {
        return formattedLastMonthDiscount({
            lastLowestPrice: amount,
            regularPrice: amount,
            currentDiscount,
            currencyCode,
            locale,
        });
    }
    if (previousDiscountArr.length) {
        const { discountedValue } = previousDiscountArr.reduce((minPrevDiscount, prevDiscount) => {
            if (!minPrevDiscount || prevDiscount.discountedValue < minPrevDiscount.discountedValue) {
                return prevDiscount;
            }
            return minPrevDiscount;
        });
        return formattedLastMonthDiscount({
            lastLowestPrice: discountedValue,
            regularPrice: amount,
            currentDiscount,
            currencyCode,
            locale,
        });
    }
    return null;
};
